import { FormControl, Grid, MenuItem, TextField } from "@mui/material";
import { get } from "lodash";
import { initialState } from "../../../slices/options/options";

type QuantityProps = {
  fieldLabel: string;
  quantity: any;
  setQuantity: (val: any) => void;
  optionKey?: string;
  defaultUnitCode?: string;
  codingSystem: string;
  disabled: boolean;
  size?: "small" | "medium";
  inputStep?: string;
  min?: number;
  max?: number;
  fullWidth?: boolean;
};

const Quantity = ({
  fieldLabel,
  quantity,
  setQuantity,
  optionKey,
  defaultUnitCode,
  codingSystem,
  disabled = false,
  size,
  inputStep,
  min,
  max,
  fullWidth = false,
}: QuantityProps) => {
  const options = optionKey ? initialState[optionKey] : [];

  const handleChange = (e) => {
    const update = { ...quantity };
    update.value = get(e, "target.value");
    setQuantity(update);
  };

  return (
    <Grid container spacing={1}>
      <Grid item xs={optionKey ? 6 : 12}>
        <TextField
          value={get(quantity, "value")}
          variant="outlined"
          label={fieldLabel}
          disabled={disabled}
          onChange={(e) => {
            handleChange(e);
          }}
          InputLabelProps={{ shrink: true }}
          InputProps={{ inputProps: { step: inputStep, max, min } }}
          size={size || "medium"}
          type="number"
          fullWidth={fullWidth}
        />
      </Grid>
      {optionKey && (
        <Grid item xs={6}>
          <FormControl variant="outlined" fullWidth>
            <TextField
              select
              variant="outlined"
              defaultValue={defaultUnitCode || "h"}
              value={get(quantity, "code")}
              disabled={disabled}
              onChange={(e) => {
                const opt = options.find(
                  (o) => o.code === (e.target.value ? e.target.value : "h"),
                );
                const update = {
                  ...quantity,
                  code: opt.code,
                  unit: opt.definition,
                  system: codingSystem,
                };

                setQuantity(update);
              }}
              label=" "
              InputLabelProps={{ shrink: true }}
              size={size || "medium"}
            >
              <MenuItem
                key={`unit-${`undefined`}-${"quantity"}`}
                value={undefined}
              >
                Select...
              </MenuItem>
              {options?.map((c, i) => (
                <MenuItem key={`unit-${c.code}-${i}`} value={c.code}>
                  {c.display}
                </MenuItem>
              ))}
            </TextField>
          </FormControl>
        </Grid>
      )}
    </Grid>
  );
};

Quantity.defaultProps = {
  inputStep: "1",
};

export default Quantity;
